import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

import { IoChevronBackOutline } from "react-icons/io5";

import { loginAuth } from "../../app/auth";
import { authDataTest } from "../../app/constant";
import Api from "../../app/api";

export default function RegisterPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [department, setDepartment] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [privacy, setPrivacy] = useState(0);

    const [loading, setLoading] = useState(false);

    const handleRegister = (e) => {
        setLoading(true);
        e.preventDefault();

        if (email.trim() === "") {
            alert("กรุณากรอกอีเมล");
            return;
        }

        if (department.trim() === "") {
            alert("กรุณากรอกอีเมล");
            return;
        }

        if (password.toString().length < 8) {
            alert("รหัสผ่านต้องมีตัวอักษรอย่างน้อย 8 ตัว");
            return;
        }

        if (password !== confirmPassword) {
            alert("รหัสผ่านและยืนยันรหัสผ่านไม่ตรงกัน");
            return;
        }

        const formData = new FormData();
        formData.append("name", name.trim());
        formData.append("email", email.trim());
        formData.append("department", department.trim());
        formData.append("privacy", privacy);
        formData.append("password", password);
        formData.append("password_confirmation", confirmPassword);

        //Send
        Api.post("/auth/register", formData)
            .then((response) => {
                const data = response.data;

                if (data.message === "OK") {
                    dispatch(loginAuth(data.obj));
                    navigate("/");
                } else if (data.message === "EMAIL_DUPLICATE_DATABASE") {
                    alert("มีผู้ใช้งานอีเมลนี้แล้วในระบบ");
                } else {
                    alert("เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
                }

                setLoading(false);
            })
            .catch((error) => {
                console.error(error);

                const data = error?.response?.data;

                if (data?.message === "EMAIL_DUPLICATE_DATABASE") {
                    alert("มีผู้ใช้งานอีเมลนี้แล้วในระบบ");
                }

                setLoading(false);
            });

        // Set AuthData Storage
        // dispatch(loginAuth(authDataTest));
        // navigate("/");
    };

    return (
        <div className="d-flex mw-100 vh-100 align-items-center justify-content-center" style={{ backgroundColor: "var(--main-background-light)" }}>
            <div className="container-sm" style={{ width: 888 }}>
                <div className="row shadow" style={{ border: "1px solid #f5f5f5" }}>
                    <div className="col-12 col-md-6 d-none d-md-block" style={{ backgroundColor: "var(--main-background-color)" }}>
                        <div className="container-text-to-image">
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/undraws/undraw_login_re_4vu2.svg`}
                                alt="undraw_login_re_4vu2"
                                style={{ width: "100%", minHeight: 600 }}
                            />

                            <div className="text-to-image-top-left">
                                <div style={{ marginLeft: -28, marginTop: 50 }}>
                                    <span className="style-back-page" onClick={() => navigate("/")}>
                                        <IoChevronBackOutline />
                                        <span className="mx-2">กลับ</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6" style={{ backgroundColor: "#ffffff" }}>
                        <div className="p-5">
                            <div className="h3">สมัครสมาชิก</div>
                            <div>R-DNAM ฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว</div>

                            <form onSubmit={handleRegister} className="mt-5">
                                <div className="mb-3">
                                    <label htmlFor="exampleInputName" className="form-label" style={{ fontSize: 12 }}>
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputName"
                                        aria-describedby="nameHelp"
                                        value={name}
                                        required
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" className="form-label" style={{ fontSize: 12 }}>
                                        Email address
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        aria-describedby="emailHelp"
                                        value={email}
                                        required
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label" style={{ fontSize: 12 }}>
                                        หน่วยงาน
                                    </label>
                                    <input type="text" className="form-control" value={department} required onChange={(e) => setDepartment(e.target.value)} />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="exampleInputPassword1" className="form-label" style={{ fontSize: 12 }}>
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="exampleInputPassword1"
                                        value={password}
                                        required
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="exampleInputPassword2" className="form-label" style={{ fontSize: 12 }}>
                                        Confirm Password
                                    </label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        id="exampleInputPassword2"
                                        value={confirmPassword}
                                        required
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <div className="form-check align-items-center">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            value={privacy}
                                            id="privacy"
                                            onChange={(e) => setPrivacy(e.target.checked ? 1 : 0)}
                                        />
                                        <label className="form-check-label" htmlFor="privacy" style={{ fontSize: 14 }}>
                                            ฉันได้อ่านและเข้าใจ{" "}
                                            <Link to="/privacy" target="_blank">
                                                นโยบายข้อมูลส่วนบุคคล
                                            </Link>{" "}
                                            ของฐานข้อมูลเครื่องหมายดีเอ็นเอข้าว
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between flex-wrap align-items-center">
                                    <div className="mt-4">
                                        <span className="a-style" onClick={() => navigate("/login")}>
                                            เข้าสู่ระบบ
                                        </span>
                                        <span className="mx-4 a-style" onClick={() => navigate("/forgot")}>
                                            ลืมรหัสผ่าน
                                        </span>
                                    </div>
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary" disabled={privacy ? loading : true}>
                                            สมัครสมาชิก
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </div>
    );
}
